"use client";
import {
  createComponent,
  createElement,
  createHook
} from "./LFJDOMBA.js";
import {
  __objRest,
  __spreadValues
} from "./2SMRF6AD.js";

// src/separator/separator.ts
var useSeparator = createHook(
  (_a) => {
    var _b = _a, { orientation = "horizontal" } = _b, props = __objRest(_b, ["orientation"]);
    props = __spreadValues({
      role: "separator",
      "aria-orientation": orientation
    }, props);
    return props;
  }
);
var Separator = createComponent((props) => {
  const htmlProps = useSeparator(props);
  return createElement("hr", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  Separator.displayName = "Separator";
}

export {
  useSeparator,
  Separator
};
